import { MarketCardListItem } from "@/components/PredictionMarket/MarketCardList/MarketCardListItem";
import { MultipleChoices } from "@/components/PredictionMarket/MarketCardList/MultipleChoices";
import { PromotionBanners } from "@/components/homepage/PromotionBanners";
import { useGetPublicPredictionMarkets } from "@/hooks/predictionMarket/useGetPublicPredictionMarkets";
import { Link } from "react-router-dom";

export const PredictionMarketTop = () => {
  const { predictionMarkets } = useGetPublicPredictionMarkets({});

  return (
    <div className="w-full">
      <PromotionBanners />
      <div className="p-5 grid gap-5">
        {predictionMarkets.map((predictionMarket) => (
          <Link to={`/prediction-market/details/${predictionMarket.id}`} key={predictionMarket.id}>
            <MarketCardListItem
              title={predictionMarket.title}
              entryOpenTime={predictionMarket.entryOpenTime}
              entryCloseTime={predictionMarket.entryCloseTime}
              choiceComponent={<MultipleChoices choices={predictionMarket.choiceNames} />}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};
